export const normalizeSearch = (value) => String(value ?? "").normalize("NFD")
  .replace(/[\u0300-\u036f]/g, "").replace(/đ/g, "d").replace(/Đ/g, "D").toLowerCase().trim();

export const isBreadWithFilling = (item) => /^BMCN(?:\d+|_[A-Z]+)?$/i.test(String(item.category || item.categoryId || item.MaNLSP || ""));
export const isAddonCategory = (category) => ["AK", "NLBL"].includes(String(category.id || category.MaNLSP).toUpperCase()) ||
  /nguyen lieu ban le|an kem/.test(normalizeSearch(category.name || category.TenLoaiSP));

export const mapCatalogProduct = (item, categoryId, categoryName = "") => ({
  id: item.MaSP, name: item.Ten_SP || item.TenSP || item.name, price: Number(item.DonGia) || 0,
  price2: Number(item.DonGia2 ?? item.DonGia) || 0, unit: item.DVT_SP, vat: item.VAT_SP,
  category: item.MaNLSP || categoryId, categoryId: item.MaNLSP || categoryId, categoryName,
  image: item.image || "/bread.png", loSX: item.LoSX || item.loSX || "",
  LoaiBanh: Number(item.LoaiBanh) === 77 || (/^\d{1,4}$/.test(String(item.MaNLSP || categoryId)) && Number(item.MaNLSP || categoryId) >= 2 && Number(item.MaNLSP || categoryId) <= 12) ? 77 : 0,
});

export const applyBreadAddons = (items, parentKey, selections) => {
  const parent = items.find((item) => String(item._uniqueId || item.id) === String(parentKey));
  if (!parent) throw new Error("Món chính không còn trong giỏ hàng.");
  const chosen = selections.filter((item) => Number.isFinite(Number(item.quantity)) && Number(item.quantity) > 0);
  const hasLinkedAddons = items.some((item) => String(item._addonParent || "") === String(parentKey));
  const splitBread = chosen.length > 0 && Number(parent.quantity) > 1 && !hasLinkedAddons && !parent._hasAddons;
  const breadKey = chosen.length > 0 && (splitBread || !parent._uniqueId)
    ? `bread-addon:${parentKey}:${Date.now()}:${Math.random()}` : parent._uniqueId || parent.id;
  const plainBread = splitBread ? { ...parent, quantity: Number(parent.quantity) - 1,
    _uniqueId: parent._uniqueId || `bread-plain:${parentKey}:${Date.now()}:${Math.random()}` } : null;
  const bread = { ...parent, _hasAddons: chosen.length > 0,
    ...(chosen.length > 0 ? { _uniqueId: breadKey } : {}),
    quantity: splitBread ? 1 : parent.quantity };
  const remaining = items.filter((item) => String(item._addonParent || "") !== String(parentKey));
  const addons = chosen.map((item) => ({
    ...item, quantity: Number(item.quantity), KmaiPT: 0,
    _addonParent: String(breadKey),
    _uniqueId: `addon:${breadKey}:${item.id}`, note: `Ăn kèm: ${parent.name}`,
  }));
  return remaining.flatMap((item) => item === parent
    ? [bread, ...addons, ...(plainBread ? [plainBread] : [])]
    : [item]);
};
